import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowDown.svg",
  "use": "ArrowDown.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowDown.svg\"><path d=\"M33.4079,53.43a1.999,1.999,0,0,1-2.8289,0L15.5744,38.4179a2.0009,2.0009,0,0,1,2.829-2.8305L30.01,47.2V12.0209a2,2,0,1,1,4,0V47.1662L45.5833,35.5874a2.001,2.001,0,1,1,2.8292,2.8305Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol